import React from 'react';
import { Grid as MaterialGrid } from '@mui/material';

const Grid = props => <MaterialGrid {...props} />;

export default Grid;
